import * as THREE from 'three';

interface IGeometryAndMaterial {
  geometry: THREE.BufferGeometry;
  material: THREE.Material | THREE.Material[];
}

const isMaterialLike = (value: unknown): value is THREE.Material | THREE.Material[] =>
  value instanceof THREE.Material || (Array.isArray(value) && value.every((item) => item instanceof THREE.Material));

/**
 * 判断对象是否同时持有几何体与材质，按属性实际值判断而不枚举类型
 * 直接写 instanceof Mesh 收窄出的是 Mesh<any, any, any>，泛型参数推不出来，geometry 与 material 会成 any
 */
export const hasGeometryAndMaterial = (object: THREE.Object3D): object is THREE.Object3D & IGeometryAndMaterial =>
  'geometry' in object &&
  object.geometry instanceof THREE.BufferGeometry &&
  'material' in object &&
  isMaterialLike(object.material);
